import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8m2.25-4a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M17 8c0 6.48-7 11-7 11S3 14.48 3 8c0-3.922 2.906-7 7-7s7 3.078 7 7m-1.75 0c0 2.609-1.421 4.953-3.05 6.758a19 19 0 0 1-2.2 2.068 19 19 0 0 1-2.2-2.068C6.171 12.953 4.75 10.608 4.75 8c0-2.984 2.151-5.25 5.25-5.25S15.25 5.016 15.25 8",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }